
    function initMap() {
        var storeCards = document.querySelectorAll('.store-card');

        storeCards.forEach(function (storeCard) {
            var storeId = storeCard.id.split('_')[1];
            var storeName = storeCard.querySelector('p.h4').innerText;
            var latitude = parseFloat(storeCard.getAttribute('data-lat'));
            var longitude = parseFloat(storeCard.getAttribute('data-lng'));
            var mapContainer = document.getElementById('map' + storeId);

            if (mapContainer) {
                var map = new google.maps.Map(mapContainer, {
                    center: { lat: latitude, lng: longitude },
                    zoom: 15,
                    zoomControl: true,
                    mapTypeControl: true,
                    fullscreenControl: false,
                    styles: [
                        {
                            featureType: 'all',
                            elementType: 'all',
                            stylers: [
                                { saturation: -100 },
                                { invert_lightness: false },
                                { hue: '#E7E6DD' }
                            ]
                        }
                    ]
                });

                var marker = new google.maps.Marker({
                    position: { lat: latitude, lng: longitude },
                    map: map,
                    label: {
                        text: storeName,
                        className: 'map-marker-label',
                        anchor: new google.maps.Point(0, -15)
                    }
                });

                var fullAddress = storeName + "<br>" + 
                    storeCard.querySelector('p:nth-of-type(3)').innerText + "<br>" + 
                    storeCard.querySelector('p:nth-of-type(4)').innerText + "<br>" + 
                    storeCard.querySelector('p:nth-of-type(7)').innerText;

                var infowindow = new google.maps.InfoWindow({
                    content: fullAddress
                });

                marker.addListener('click', function () {
                    infowindow.open(map, marker);
                });
            }
        });
    }
